import { render, staticRenderFns } from "./SubmitResources.vue?vue&type=template&id=43321c3b&scoped=true"
import script from "./SubmitResources.vue?vue&type=script&lang=js"
export * from "./SubmitResources.vue?vue&type=script&lang=js"
import style0 from "./SubmitResources.vue?vue&type=style&index=0&id=43321c3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_7gdvgtoi4hlwpf77n6k44zt3ui/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43321c3b",
  null
  
)

export default component.exports